// Module
var code = "<md-slider-container>\r\n    <md-slider flex md-discrete ng-model=\"vm.contraste\" step=\"2\" min=\"-10\" max=\"100\" aria-label=\"rating\" ng-change=\"vm.contrast()\">\r\n    </md-slider>\r\n</md-slider-container>";
// Exports
module.exports = code;